module.exports = __webpack_public_path__ + "img/400-bad-request.77334bd1.svg";